import React, { Component } from "react";
import FooterComponent from "../components/footer/footerComponent";
import LocationSectionComponent from "../components/mainpage/locationSection";
import MainBookingSectionComponent from "../components/mainpage/mainBookingSection.jsx";
import ProductsSectionComponent from "../components/mainpage/productsSection";
import ServicesSectionComponent from "../components/mainpage/servicesSection";
import HeaderComponent from "../components/header/header";


class MainPageComponent extends Component {
    state = {  } 
    render() { 
        return (
        <div>
            <HeaderComponent navBarMode="main"/>
            <MainBookingSectionComponent/>
            <ServicesSectionComponent/>
            <ProductsSectionComponent />
            <LocationSectionComponent/>
            <FooterComponent/>
        </div>);
    }
}
 
export default MainPageComponent;